import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';
import { PaymentOption } from '../paymentOption';

export interface PaymentOptionListModel extends BaseFieldModel {
  defaultValue: string[] | undefined;
  options: PaymentOption[];
  type: FieldType.PaymentOptionList;
}
export class PaymentOptionList extends BaseField implements PaymentOptionListModel {
  public defaultValue: string[] | undefined;
  public options: PaymentOption[] = [];
  public type: FieldType.PaymentOptionList = FieldType.PaymentOptionList;

  constructor(cultures: string[]) {
    super(FieldType.PaymentOptionList, cultures);
  }
}
